/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  material_id: z.number(),
  stirring_time_minutes: z.number(),
  stirring_method_id: z.number().nullable(),
  construction_method_id: z.number().nullable(),
  remarks: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MixRatioDefinitionBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MixRatioDefinitionBase = z.infer<typeof base>;
export type MixRatioDefinitionBasePutPayload = z.infer<typeof put>;
export type MixRatioDefinitionBasePatchPayload = z.infer<typeof patch>;
export type MixRatioDefinitionBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MixRatioDefinitionBaseCreateAttributes = z.infer<typeof create>;
export type MixRatioDefinitionBaseUpdateAttributes = z.infer<typeof update>;
export type MixRatioDefinitionBaseCacheAttributes = z.infer<typeof cache>;
export type MixRatioDefinitionBaseCachesAttributes = z.infer<typeof caches>;